import { useState, useEffect } from 'react'

import CustomModal from 'components/organisms/CustomModal'
import { QUESTIONNAIRE_SUBMIT_TO_ATTORNEY_DESCRIPTION } from '../constants'
import { Button, Form } from 'react-bootstrap'

import './styles.scss'

export interface SubmitToAttorneyModalProps {
  show: boolean
  showError: boolean
  isLoading: boolean
  caseId: number
  onHide: () => void
  onSubmit: () => void
}

const QuestionnaireSubmitToAttorneyModal = (
  props: SubmitToAttorneyModalProps
): JSX.Element => {
  const [enableSubmit, setEnableSubmit] = useState<boolean>(false)

  function onClose() {
    setEnableSubmit(false)
    props.onHide()
  }

  useEffect(() => {
    setEnableSubmit(false)
  }, [props.show])

  return (
    <CustomModal
      show={props.show}
      showClose={true}
      showFooter={true}
      onHide={onClose}
      title='Submit to attorney'
      showMessage={props.showError}
      messageText='Your questionnaire could not be submitted at this time. Please try again later.'
      isLoading={props.isLoading}
      loadingText='Submitting...'
    >
      <div
        className='submit-to-attorney-description-header'
        data-testid='submit-to-attorney-description-header'
      >
        You are about to submit the questionnaire to your attorney.
      </div>
      <div
        className='submit-to-attorny-description-content'
        data-testid='submit-to-attorny-description-content'
      >
        {QUESTIONNAIRE_SUBMIT_TO_ATTORNEY_DESCRIPTION}
      </div>

      <Form.Group controlId='acceptTerms' className='accept-terms'>
        <Form.Check
          type='checkbox'
          label='I (We) the debtor(s) agree'
          onChange={(event) => setEnableSubmit(event.target.checked)}
          className='accept-terms-checkbox'
          data-testid='accept-terms-checkbox'
        />
      </Form.Group>

      <div className='submit-to-attorney-important'>
        <span className='mdi mdi-information-outline' />
        <span> Important</span>
      </div>
      <div className='submit-to-attorney-important-text'>
        If you would like to change any information, please click ‘Cancel’ to go
        back and change your answers.
      </div>
      <div className='border-container' />
      <div className='button-container'>
        <Button
          onClick={props.onSubmit}
          disabled={!enableSubmit}
          className='submit-button'
          data-testid='submit-btn'
        >
          Submit to attorney
        </Button>
        <Button
          variant='outline-secondary'
          onClick={onClose}
          className='attorney-cancel-button'
          data-testid='cancel-btn'
        >
          Cancel
        </Button>
      </div>
    </CustomModal>
  )
}

export default QuestionnaireSubmitToAttorneyModal
